import { VirtualMeetingIcon } from "./VirtualMeetingIcon";

export default VirtualMeetingIcon;
